import { buildApiUrl, fetchJSON, validateRequiredParams } from './crmApi';

export interface CompanySiteMember {
  id: string;
  organization_id: string;
  site_id: string;
  user_id: string;
  role: 'staff' | 'manager' | 'visitor';
  created_at: string;
}

const companySiteMembersService = {
  async list(organization_id: string, site_id: string): Promise<{ data: CompanySiteMember[] }>{
    validateRequiredParams({ organization_id, site_id }, ['organization_id', 'site_id'], {
      service: 'companySiteMembersService.list'
    });
    const url = buildApiUrl(`/api/crm/sites/${encodeURIComponent(site_id)}/members`, { organization_id });
    return fetchJSON(url, {
      description: 'List company site members',
      context: { organization_id, site_id }
    });
  },
  async add(organization_id: string, site_id: string, user_id: string, role: CompanySiteMember['role'] = 'staff'): Promise<{ data: CompanySiteMember }>{
    validateRequiredParams({ organization_id, site_id, user_id, role }, ['organization_id', 'site_id', 'user_id', 'role'], {
      service: 'companySiteMembersService.add'
    });
    const url = buildApiUrl(`/api/crm/sites/${encodeURIComponent(site_id)}/members`);
    return fetchJSON(url, {
      method: 'POST',
      body: { organization_id, site_id, user_id, role },
      description: 'Add company site member',
      context: { organization_id, site_id, user_id, role }
    });
  },
  async remove(organization_id: string, site_id: string, id: string): Promise<{ success: boolean }>{
    validateRequiredParams({ organization_id, site_id, id }, ['organization_id', 'site_id', 'id'], {
      service: 'companySiteMembersService.remove'
    });
    const url = buildApiUrl(`/api/crm/sites/${encodeURIComponent(site_id)}/members/${encodeURIComponent(id)}`, { organization_id });
    return fetchJSON(url, {
      method: 'DELETE',
      description: 'Remove company site member',
      context: { organization_id, site_id, id }
    });
  }
};

export default companySiteMembersService;
